import {StrictEventEmitter} from '@gongxigames/framework/core/services/strictEventEmitter';

export type UIMenuBarEvents = {
    'home': void;
    'fullscreen': void;
    'info': void;
    'game_rules': void;
    'history': void;
    'cashier': void;
    'support': void;
    'logout': void;
    'close': void;
};

export const uiMenuEmitter = new StrictEventEmitter<UIMenuBarEvents>();